import React from 'react';
import { fetchWrapper } from '../../APIManager';
const CategoriesStateContext = /*#__PURE__*/React.createContext();
const CategoriesDispatchContext = /*#__PURE__*/React.createContext();

// TEST
const initialState = {
  forumCategories: [],
  allPostsImagePaths: {
    header: '',
    icon: ''
  },
  rootProductCategory: null,
  rootForumCategory: null,
  selectedCategory: null
};

/** REDUCER **/
function CategoriesReducer(state, action) {
  switch (action.type) {
    case 'SET_FORUM_CATEGORIES_LIST':
      return {
        ...state,
        forumCategories: action.payload
      };
    case 'SET_ROOT_CATEGORY':
      return {
        ...state,
        rootProductCategory: action.payload
      };
    case 'SET_ROOT_FORUM_CATEGORY':
      return {
        ...state,
        rootForumCategory: action.payload
      };
    case 'SET_ALL_POSTS_IMAGE_PATHS':
      return {
        ...state,
        allPostsImagePaths: action.payload
      };
    case 'GET_SELECTED_CATEGORY':
      return selectedCategory;
    case 'SET_SELECTED_CATEGORY':
      return {
        ...state,
        selectedCategory: action.payload
      };
    case 'GET_INITIAL':
      return initialState;
    default:
      {
        throw new Error('Unhandled action type caught');
      }
  }
}

/** PROVIDER **/
function CategoriesProvider({
  value,
  children
}) {
  const [state, dispatch] = React.useReducer(CategoriesReducer, initialState);
  return /*#__PURE__*/React.createElement(CategoriesStateContext.Provider, {
    value: state
  }, /*#__PURE__*/React.createElement(CategoriesDispatchContext.Provider, {
    value: dispatch
  }, children));
}

/** STATE/DISPATCH HOOKS **/
function useCategoriesState() {
  const context = React.useContext(CategoriesStateContext);
  if (context === undefined) {
    throw new Error('useCategoriesState must be used within a CategoriesProvider');
  }
  return context;
}
function useCategoriesDispatch() {
  const context = React.useContext(CategoriesDispatchContext);
  if (context === undefined) {
    throw new Error('useCategoriesDispatch must be used within a CategoriesProvider');
  }
  return context;
}

/** API **/
const categoriesAPI = {
  getCategories: async (url, apiKey, product) => {
    if (!product) throw 'Must include a product to get categories';
    try {
      const includeSubcategories = 'true';
      const slug = `/categories.json?include_subcategories=${includeSubcategories}`;
      const response = await fetchWrapper(url, slug, apiKey);
      if (response && response.category_list && response.category_list.categories && response.category_list.categories.length) {
        // parse through response to only return the categories for this particular product
        let thisProductCategory = response.category_list.categories.find(c => c.slug == product);
        return thisProductCategory;
      }
      throw new Error('Could not get categories list.');
    } catch (err) {
      return [];
    }
  }
};
export { CategoriesProvider, useCategoriesState, useCategoriesDispatch, categoriesAPI };
//# sourceMappingURL=index.js.map